
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import countTo from "vue-count-to";
import Multiselect from "vue-multiselect";
import OrderReciept from "@/components/orderReciept";
import DatePicker from "vue2-datepicker";
export default {
  page: {
    title: "Purchased Vouchers Table",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    countTo,
    Multiselect,
    OrderReciept,
    DatePicker,
  },
  data() {
    return {
      tableData: [],
      voucherData: [],
      daterange: [],

      title: "Purchased Vouchers ",
      items: [
        {
          text: "View",
        },
        {
          text: "Purchased Vouchers",
          active: true,
        },
      ],
      voucherTypeArr: [
        { typeID: 1, name: "Cash Voucher" },
        { typeID: 2, name: "Product Voucher" },
      ],
      statusArr: [
        { id: 1, status: "Available" },
        { id: 2, status: "Redeemed" },
      ],
      orderDetails: [],
      orderedItemArr: [],
      orderItemAddonArr: [],
      orderStatusArr: [],
      status: "",
      voucherType: "",
      dateFilter: "",
      userVoucherID: 0,
      branches: [],
      branchID: "",
      restBranchID: "",
      brandData: "",
      brandArr: [],
      countryArr: [],
      country: "",
      cityArr: [],
      city: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "voucherTitle",
          sortable: true,
        },
        {
          key: "voucherIdentifier",
          sortable: true,
          tdClass: "align-right",
        },
        {
          key: "userName",
          lable: "Customer Name",
          sortable: true,
        },
        {
          key: "amount",
          sortable: true,
          tdClass: "align-right",
        },
        {
          key: "orderID",
          sortable: true,
          tdClass: "align-right",
        },
        {
          key: "voucherType",
          sortable: true,
        },
        {
          key: "product",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },

        {
          key: "created",
          sortable: true,
        },
        {
          key: "expiryDate",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;

    if (this.$route.params.id) {
      sessionStorage.setItem("userVoucherID", this.$route.params.id);
    }

    if (this.$route.params.type == "voucherPlan") {
      this.userVoucherID = sessionStorage.getItem("userVoucherID");
    } else {
      this.userVoucherID = 0;
    }

    if (this.$storageData.login_type == 2 || this.$storageData.profile.empTypeID == 2 || this.$storageData.profile.empTypeID == 11) {
      this.getRestaurantCountry();
    } else {
      this.getAllPurchasedVouchers();
    }
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    downloadSample() {
      this.axios
        .post(this.$loggedRole+"/exportExcel",
          {
            exportData: this.tableData,
            page: "PurchasedVouchers",
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "PurchasedVouchers.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },

    getAllPurchasedVouchers() {
      this.axios
        .post(this.$loggedRole+"/getAllPurchasedVouchers", {
          restBranchID:
            this.$storageData.login_type == 2 ||
            this.$storageData.profile.empTypeID == 2 ||
            this.$storageData.profile.empTypeID == 11
              ? this.restBranchID
              : this.$storageData.profile.restBranchID,
          userVoucherID: this.userVoucherID,
          dateFilter: this.daterange ? this.daterange : [],
        })
        .then((response) => {
          //Then injecting the result to datatable parameters.

          this.tableData = response.data.data;
          this.voucherData = response.data.cardVoucherData;
          //console.log((response));
        });
    },
    applyFilter() {
      this.axios
        .post(this.$loggedRole+"/getAllPurchasedVouchers", {
          restBranchID:
            this.$storageData.login_type == 2 ||
            this.$storageData.profile.empTypeID == 2 ||
            this.$storageData.profile.empTypeID == 11
              ? this.restBranchID
              : this.$storageData.profile.restBranchID,
          dateFilter: this.daterange ? this.daterange : [],
          status: this.status ? this.status.id : 0,
          voucherType: this.voucherType ? this.voucherType.typeID : 0,
          userVoucherID: this.userVoucherID,
        })
        .then((response) => {
          //Then injecting the result to datatable parameters.

          this.tableData = response.data.data;
          this.voucherData = response.data.cardVoucherData;
          //console.log((response));
        });
    },
    getRestaurantBrandsByCompanyID() {
      this.axios
        .post(this.$loggedRole+"/getRestaurantBrandsByCompanyID", {
          companyID: this.$storageData.profile.companyID,
        })
        .then((response) => {
          this.brandArr = response.data.data;
          this.brandData = this.brandArr ? this.brandArr[0] : "";
          this.readRestaurantBranchData();
        });
    },
    getRestaurantCountry() {
      this.axios
        .post(this.$loggedRole+"/getRestaurantCountry", {
          restID: this.$storageData.profile.restID,
          company_id:this.$storageData.profile.companyID
        })
        .then((response) => {
          this.countryArr = response.data.data;
          this.country = this.countryArr ? this.countryArr[0] : "";
          this.getRestaurantCities();
        });
    },
    getRestaurantCities() {
      this.axios
        .post(this.$loggedRole+"/getRestaurantCities", {
          restID:
            this.$storageData.login_type == 1
              ? this.restaurantID.restID
              : this.$storageData.profile.restID,
          country: this.country ? this.country.country : "",
          company_id:this.$storageData.profile.companyID
        })
        .then((response) => {
          this.cityArr = response.data.data;
          this.city = this.cityArr ? this.cityArr[0] : "";
          if (this.$storageData.profile.empTypeID == 11) {
            this.getRestaurantBrandsByCompanyID();
          } else {
            this.readRestaurantBranchData();
          }
        });
    },

    readRestaurantBranchData() {
      this.axios
        .post(this.$loggedRole+"/getRestaurantBranchByRestID", {
          restID:
            this.brandData != ""
              ? this.brandData.restID
              : this.$storageData.profile.restID,
          restBranchID: 0,
          empTypeID: this.$storageData.profile.empTypeID,
          city: this.city ? this.city.city : "",
        })
        .then((response) => {
          this.branches = response.data.data;
          this.branchID = this.branches ? this.branches[0] : "";
          this.restBranchID = this.branchID ? this.branchID.restBranchID : "";
          this.getAllPurchasedVouchers();
        });
    },

    clearFilter() {
      this.daterange = [];
      this.status = "";
      this.voucherType = "";
      this.getAllPurchasedVouchers();
    },
    viewOrderDetails(orderID) {
      // alert(orderID);
      this.$root.$emit("bv::show::modal", "modal-lg-orderDetails");
      this.axios
        .post(this.$loggedRole+"/getOrderDetailsByID", { orderID: orderID })
        .then((result) => {
          this.orderDetails = result.data.data;
          this.orderStatusArr = result.data.data.orderStatus;
          //  console.log(result.data.data.orderedItemArr);
          this.orderedItemArr = result.data.data.orderedItemArr;
          // this.orderItemAddonArr = result.data.orderItemAddonArr;
        });
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card" style="margin-top: -30px">
      <div class="card-body">
        <div class="inner mb-2 row">
          <div class="row">
            <div
              class="col-md-3"
              v-if="
                this.$storageData.profile.empTypeID == 2 ||
                this.$storageData.profile.empTypeID == 11
              "
            >
              <label>Select Country </label>
              <multiselect
                v-model="country"
                :options="countryArr"
                track-by="country"
                label="country"
                @input="getRestaurantCities()"
                :show-labels="false"
              ></multiselect>
            </div>
            <div
              class="col-md-3"
              v-if="
                this.$storageData.login_type == 2 ||
                this.$storageData.profile.empTypeID == 2 ||
                this.$storageData.profile.empTypeID == 11
              "
            >
              <label>Select City </label>
              <multiselect
                v-model="city"
                :options="cityArr"
                track-by="city"
                label="city"
                @input="readRestaurantBranchData()"
                :show-labels="false"
              ></multiselect>
            </div>
            <!--END Cities List-->
            <div class="col-md-3 mb-3" v-if="this.$storageData.profile.empTypeID == 11">
              <label>Select Restaurant Brand</label>
              <multiselect
                v-model="brandData"
                :options="brandArr"
                track-by="restID"
                label="name"
                @input="readRestaurantBranchData()"
                :show-labels="false"
              ></multiselect>
            </div>
            <div
              class="col-md-3"
              v-if="
                this.$storageData.login_type == 2 ||
                this.$storageData.profile.empTypeID == 2 ||
                this.$storageData.profile.empTypeID == 11
              "
            >
              <label>Select Restaurant Branch </label>
              <multiselect
                v-model="branchID"
                :options="branches"
                track-by="restBranchID"
                label="branchName"
                :show-labels="false"
                @input="onchangeBranch()"
              ></multiselect>
            </div>
            <!-- <div class="col-md-3" style="position: absolute;right: 7%;top: 84px;width: 19%;">
          <label>Date Range* </label>
            <date-picker v-model="daterange" format="DD MMM Y" range append-to-body lang="en" confirm @input="applyFilter();"></date-picker>
           
          </div>
           
          <button v-if="daterange.length>0" class="btn btn-themeBrown col-md-1" style="position: absolute;right: 0%;top: 110px;" v-on:click="clearFilter()"> Clear </button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div>
              <h4 class="mb-1 mt-1">
                {{ voucherData.totalActiveVouchers }} of
                {{ voucherData.totalVouchers }}
                <!-- <span data-plugin="counterup">
                            <countTo :startVal="1000" :endVal="voucherData.totalAmountRedeemed" :duration="2000"></countTo>
                        </span> -->
              </h4>
              <p class="text-muted mb-0">Total Active Vouchers</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div>
              <h4 class="mb-1 mt-1">
                {{ voucherData.redeemedVouchers }}
                <!-- <span data-plugin="counterup">
                            <countTo :startVal="1000" :endVal="voucherData.redeemedVouchers" :duration="2000"></countTo>
                        </span> -->
              </h4>
              <p class="text-muted mb-0">Redeemed Vouchers</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div>
              <h4 class="mb-1 mt-1">
                ₹
                <span data-plugin="counterup">
                  <countTo
                    :startVal="1000"
                    :endVal="voucherData.totalAmountRedeemed"
                    :duration="2000"
                  ></countTo>
                </span>
              </h4>
              <p class="text-muted mb-0">Total Amount Redeemed</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div>
              <h4 class="mb-1 mt-1">
                <span data-plugin="counterup">
                  <countTo
                    :startVal="1000"
                    :endVal="voucherData.availableVouchers"
                    :duration="2000"
                  ></countTo>
                </span>
              </h4>
              <p class="text-muted mb-0">Available Vouchers</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div>
              <h4 class="mb-1 mt-1">
                <span data-plugin="counterup">
                  <countTo
                    :startVal="1000"
                    :endVal="voucherData.expiredVouchers"
                    :duration="2000"
                  ></countTo>
                </span>
              </h4>
              <p class="text-muted mb-0">Expired Vouchers</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-4" style="margin-bottom: 15px;" v-if="this.$storageData.login_type == 1">
                <div role="group" class="btn-group">
                  <button
                    type="button"
                    class="btn btn-themeBrown"
                    @click="downloadSample()"
                  >
                    Excel
                  </button>
                </div>
              </div>
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show &nbsp;&nbsp;
                    <b-form-select
                      style="margin-left: 5px; margin-right: 5px"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;&nbsp;&nbsp; entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-4 row">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div class="row mb-2">
              <div class="col-sm-6 col-md-2">
                <label class="form-label" for="formrow-voucherType-input"
                  >Voucher Type</label
                >
                <multiselect
                  v-model="voucherType"
                  :options="voucherTypeArr"
                  :show-labels="false"
                  track-by="typeID"
                  label="name"
                  @input="applyFilter()"
                >
                </multiselect>
              </div>

              <div class="col-sm-6 col-md-2">
                <label class="form-label" for="formrow-status-input"
                  >Status</label
                >
                <multiselect
                  v-model="status"
                  :options="statusArr"
                  :show-labels="false"
                  track-by="id"
                  label="status"
                  @input="applyFilter()"
                >
                </multiselect>
              </div>
              <div class="col-md-3">
                <label>Date Range* </label>
                <date-picker
                  v-model="daterange"
                  format="DD MMM Y"
                  range
                  append-to-body
                  value-type="format"
                  lang="en"
                  confirm
                  @input="applyFilter()"
                ></date-picker>
              </div>

              <button
                class="btn btn-themeBrown col-md-1 mt-4"
                v-on:click="clearFilter()"
              >
                Clear
              </button>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                striped
                hover
                outlined
                bordered
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                fixed-header
              >
                <!-- <template #cell(Action)>
                  <i class="uil uil-edit-alt" title="Edit" style="font-size: 19px;"></i>
                  <i class="mdi mdi-delete" title="Delete" style="font-size: 19px;"></i>
                </template> -->

                <template v-slot:cell(amount)="data">
                  <span v-if="data.item.amount">₹{{ data.item.amount }}</span>
                </template>

                <template v-slot:cell(voucherIdentifier)="data">
                  <span v-if="data.item.voucherIdentifier"
                    >#{{ data.item.voucherIdentifier }}</span
                  >
                </template>

                <template v-slot:cell(product)="data">
                  <span v-if="data.item.product">{{ data.item.product }}</span>
                  <span v-else> - </span>
                </template>

                <template v-slot:cell(orderID)="data">
                  <span
                    v-if="data.item.orderID"
                    style="cursor: pointer; color: rgb(243, 118, 106);"
                    @click="viewOrderDetails(data.item.id)"
                    >{{ data.item.orderID }}</span
                  >
                  <span v-else> - </span>
                </template>

                <template v-slot:cell(status)="data">
                  <span v-if="data.item.status == 1" style="color: green">
                    Available
                  </span>
                  <span v-else style="color: #f3766a"> Redeemed </span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modals -->
    <OrderReciept
      :orderDetails="this.orderDetails"
      :orderedItemArr="this.orderedItemArr"
      :orderStatusArr="this.orderStatusArr"
    >
    </OrderReciept>
  </Layout>
</template>

